import React from 'react';

import Button from 'components/Button';
import './style.scss';

const MailThreadsListHeader = () => {
  return (
    <div className="MailThreadsListHeader">
      <div className="wrapper-full">
        <h1>{__('members.mail.title')}</h1>
        <Button isSmall hasIcon isYellow iconType="message" to="/messages/new">{__('members.mail.mailTeam.title')}</Button>
      </div>
    </div>
  );
};

export default MailThreadsListHeader;



/** WEBPACK FOOTER **
 ** ./src/members/Main/Mail/MailThreadsList/MailThreadsListHeader/index.js
 **/